module.exports = __webpack_public_path__ + "img/labs.a0c32729.svg";